import { render, staticRenderFns } from "./SuccessfulBiddersOptions.vue?vue&type=template&id=a99e1762&"
import script from "./SuccessfulBiddersOptions.vue?vue&type=script&lang=js&"
export * from "./SuccessfulBiddersOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a99e1762')) {
      api.createRecord('a99e1762', component.options)
    } else {
      api.reload('a99e1762', component.options)
    }
    module.hot.accept("./SuccessfulBiddersOptions.vue?vue&type=template&id=a99e1762&", function () {
      api.rerender('a99e1762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/successfulBidder/views/components/SuccessfulBiddersOptions.vue"
export default component.exports